<!--
 * @Author: houmy
 * @Date: 2023-09-18 21:31:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-30 16:07:26
 * @FilePath: \zx-home\src\views\NewsDetail.vue
 * @Description: 
 * 
-->

<template>
    <div class="page">
        <Contact></Contact>
        <img class="newsBanner" src="../assets/img/news/banner.png" alt="">
        <div class=" home-box">
            <div class="newsDetail">

                <div class="detailPageTitle">
                    <router-link to="/">首页</router-link>
                    <img src="../assets/img/news/arrow.png" alt="">
                    <router-link to="/news">新闻动态</router-link>
                    <img src="../assets/img/news/arrow.png" alt="">
                    文章详情
                </div>
                <div class="newsDetailMain">
                    <h1> {{ newsDetail.title }}</h1>
                    <span>发布时间：{{ newsDetail.time }}</span>
                    <div class="newsContent" v-html="newsDetail.content"></div>
                </div>
                <div class="newsFooter">
                    <button class="commonBtn backList" @click="handleBack">
                        返回列表
                    </button>
                    <p v-if="lastTitle" class="cur-poi" @click="changeDetail(1)">上一篇：《{{ lastTitle }}》</p>
                    <p v-else class="grayText">上一篇：没有更多了</p>
                    <p v-if="nextTitle" class="cur-poi" @click="changeDetail(2)">下一篇：《{{ nextTitle }}》</p>
                    <p v-else class="grayText">下一篇：没有更多了</p>

                </div>
            </div>

        </div>
    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
export default {
    components: {
        Contact
    },
    data() {
        return {
            newsDetail: {},
            lastTitle: "",
            nextTitle: ""
        };
    },
    mounted() {
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
        this.index = Number(this.$route.query.index);
        this.lastTitle = this.$route.query.lastTitle;
        this.nextTitle = this.$route.query.nextTitle;
        this.newsDetail = JSON.parse(localStorage.getItem('newsDetail'))
        this.newsList = JSON.parse(localStorage.getItem('newsList'))

    },
    methods: {
        changeDetail(flag) {
            if (flag == 1) {
                this.newsDetail = this.newsList[this.index - 1]
                this.index = this.index - 1
                this.lastTitle = this.newsList[this.index - 1] ? this.newsList[this.index - 1].title : ''
                this.nextTitle = this.newsList[this.index + 1] ? this.newsList[this.index + 1].title : ''
                // if(!this.lastTitle){
                //     this.index = this.index+1
                // }
            } else {
                this.newsDetail = this.newsList[this.index + 1]
                this.index = this.index + 1
                this.lastTitle = this.newsList[this.index - 1] ? this.newsList[this.index - 1].title : ''
                this.nextTitle = this.newsList[this.index + 1] ? this.newsList[this.index + 1].title : ''

            }
            this.$nextTick(() => {
            window.scrollTo(0, 0)
        })

        },
        handleBack() {
            this.$router.push('/news')
        }
    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/NewsDetail.vue